import { useNavigate } from 'react-router-dom'
import * as actions from '@actions'
import { useFormik } from 'formik'
import { useEffect } from 'react'
import { TextInput } from '@components/shared/TextInput'

/* type LocationState = { token?: string }

type Props = RouteComponentProps<{}, StaticContext, LocationState> */

// export interface NewBilling extends Omit<Card, 'id' | 'name' | 'type' | 'number' | 'cvv' | 'expirationDate'> {
//     name: string
//     /* type: SelectboxOption<type>;
//   number: number;
//   cvv: number;
//   expirationDateMonth: SelectboxOption;
//   expirationDateYear: SelectboxOption; */
// }

export const BILLING_INITIAL_VALUES = {
    address: '',
    zip: '',
    name: '',
    
    /* type: typesAsOptions[0],
  number: 0,
  cvv: 0,
  expirationDateMonth: monthsAsOptions[0],
  expirationDateYear: yearsAsOptions[0], */
} /* as NewBilling */

const SetBilling = props => {
    
    const navigate = useNavigate()
    
    const token = props?.location?.state?.token
    
    useEffect(() => {
        if (token) {
            return
        }
        
        navigate('/signin')
    }, [token])
    
    const formik = useFormik({
        initialValues: BILLING_INITIAL_VALUES,
        validate: values => {
            const errors = {}
            const { address, zip, name /* number, cvv */ } = values
            
            const message = 'Required'
            
            if (!address) {
                errors.address = message
            }
            
            if (!zip) {
                errors.zip = message
            }
            
            if (!name) {
                errors.name = message
            }
            
            /* if (!number) {
        errors.number = message;
      }
      
      if (!cvv) {
        errors.cvv = message;
      } */
            
            return errors
        },
        onSubmit: async values => {
            if (!token) {
                return
            }
            
            const newCard = {
                ...values,
                
                /* type: values.type.value,
        expirationDate: new Date(`01-${values.expirationDateMonth.label}-${values.expirationDateYear.label}`), */
            }
            
            await actions.addUserBilling(token, newCard)
            navigate('/signin')
        },
    })
    
    const { values, handleSubmit, handleChange, touched, errors } = formik
    
    return (
        <div className="container">
            <div className="row justify-center items-center" style={{ height: '99vh' }}>
                <div className="col-12 col-md-6 col-xl-4 mr-7">
                    <div
                        style={{
                            marginBottom: '25px',
                            width: '80%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: '105px',
                        }}>
                        <img src="img/logo.png" width="100%" height="100%" alt="" />
                    </div>
                    <div className="text-center" style={{ width: '530px' }}>
                        <h2>Pay As You Go Pricing</h2>
                        <div className="text-center modal-body">
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    County-level Grantor/Grantee Search
                                </div>
                                <div className="pt-2 col-4">Free</div>
                            </div>
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    Premium Search(By Legal Description)
                                </div>
                                <div className="pt-2 col-4">$5 per search</div>
                            </div>
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    View & Download Documents
                                </div>
                                <div className="pt-2 col-4">$2 per doc</div>
                            </div>
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    Advanced Statewide Search
                                </div>
                                <div className="pt-2 col-4">$5 per search</div>
                            </div>
                            <div
                                className="row"
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    Upload and Annotate Documents
                                </div>
                                <div className="pt-2 col-4">$1 per doc</div>
                            </div>
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    Build & Export Runsheets
                                </div>
                                <div className="pt-2 col-4">Free</div>
                            </div>
                            <div
                                className="row "
                                style={{ border: '1px solid white', borderRadius: '6px', minHeight: '37px' }}>
                                <div className="pt-2 col-8" style={{ borderRight: '5px solid white' }}>
                                    Build & Export Runsheets Tracts & Ownership
                                </div>
                                <div className="pt-2 col-4">$15 per tract</div>
                            </div>
                        </div>
                        <section>
                            <form onSubmit={handleSubmit}>
                                <TextInput
                                    name="name"
                                    inputClassName={touched.name && errors.name ? 'border-danger' : ''}
                                    handleChange={handleChange}
                                    value={values.name}
                                    placeholder="Name (as it appears on the card)"/>
                                
                                <TextInput
                                    name="address"
                                    inputClassName={` ${touched.address && errors.address ? 'border-danger' : ''}`}
                                    handleChange={handleChange}
                                    value={values.address}
                                    placeholder="Billing Address"/>
                                
                                <TextInput
                                    type="text"
                                    name="zip"
                                    inputClassName={` ${touched.zip && errors.zip ? 'border-danger' : ''}`}
                                    handleChange={handleChange}
                                    value={values.zip}
                                    placeholder="Billing Zip"
                                    pattern="[0-9]*"/>
                                
                                {/* <Selectbox
                  name='type'
                  handleChange={setFieldValue}
                  errorClassName={touched.type && errors.type ? `border-danger` : ''}
                  className='p-0 form-control'
                  option={values.type}
                  options={typesAsOptions}
                  placeholder='Card Type'
                />
                
                <TextInput
                  type='text'
                  name='number'
                  inputClassName={` ${touched.number && errors.number ? `border-danger` : ''}`}
                  handleChange={handleChange}
                  value={values.number || ''}
                  placeholder='Card Number'
                  pattern='[0-9]*'
                />
                
                <TextInput
                  type='text'
                  name='cvv'
                  inputClassName={` ${touched.cvv && errors.cvv ? `border-danger` : ''}`}
                  handleChange={handleChange}
                  value={values.cvv || ''}
                  placeholder='CVV Number'
                  pattern='[0-9]*'
                />
                <div className='row'>
                  <div className='mb-4 col-4 flex justify-center items-center'>Expiration Date</div>
                  <Selectbox
                    name='expirationDateMonth'
                    handleChange={setFieldValue}
                    className='col-4'
                    errorClassName={touched.expirationDateMonth && errors.expirationDateMonth ? `border-danger` : ''}
                    option={values.expirationDateMonth}
                    options={monthsAsOptions}
                  />
                  <Selectbox
                    name='expirationDateYear'
                    handleChange={setFieldValue}
                    className='col-4'
                    errorClassName={touched.expirationDateYear && errors.expirationDateYear ? `border-danger` : ''}
                    option={values.expirationDateYear}
                    options={yearsAsOptions}
                  />
                </div> */}
                                
                                <div className="mb-2 form-group">
                                    <div className="input-group input-group-merge ">
                                        <input
                                            type="submit"
                                            value="Next"
                                            className="mb-3 btn btn-lg btn-block btn-primary sign-in-button"/>
                                    </div>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetBilling
